// removed by extract-text-webpack-plugin
module.exports = {"CoilsForOrder":"CoilsForOrder__xi3Uj","summaryRow":"summaryRow__3-oWI","summaryPosition":"summaryPosition__2gVEY","breakBefore":"breakBefore__2Nx-J","flex":"flex__3YYD5"};